const decorator = {
  hydrate: function (hydrate, ...args) {
    const [element, container, callback] = [...args];

    performance.mark("reactHydrationStarted");

    const hydrationCompletionCallback = () => {
      performance.mark("reactHydrationCompleted");
      if (callback) {
        callback();
      }
    };

    hydrate(element, container, hydrationCompletionCallback);
  },

  render: function (render, ...args) {
    const [element, container, callback] = [...args];

    performance.mark("reactHydrationStarted");

    const hydrationCompletionCallback = () => {
      performance.mark("reactHydrationCompleted");
      if (callback) {
        callback();
      }
    };

    render(element, container, hydrationCompletionCallback);
  },
};

export default decorator;